import { render } from "./Concept_m.vue?vue&type=template&id=6ad8000e"
import script from "./Concept_m.vue?vue&type=script&lang=js"
export * from "./Concept_m.vue?vue&type=script&lang=js"
script.render = render

export default script